import React, {Component} from 'react'
import {Button, Col, DatePicker, Form, Input, Row, Select, Spin, Table,} from 'antd';
import {baseUrl} from '../../api'
import LinkButton from "../../components/link-button";
import ajax from "../../api/ajax";
import OrderSubSetModalForm from "./order-sub-set-modal";

const PAGE_SIZE = 10;
class OrderSubSet extends Component{
    state={
        loading: false,
        visible: false,
        pageNum:1,
        orderId:null,
    }

    // 日期选择
    onDateChange = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryFromDt: dateString
        })
    }
    // 日期选择
    onDateChange2 = (value, dateString) => {
        console.log(value, dateString)
        this.setState({
            deliveryToDt: dateString
        })
    }
    updateVisible =(visible)=>{
        this.setState({
            visible:visible
        })
    }
    searchList=(page)=>{
        this.props.form.validateFields((err, values) => {
            // values.pageNum = this.state.pageNum
            values.pageNum = !!page?page:1;
            this.setState({
                pageNum:!!page?page:1
            })
            values.pageSize= PAGE_SIZE
            if (!err) {
                this.getOrderList(values);
            }
        });
    }
    getOrderList= (params) => {
        this.setState({
            loading:true,
        })
        if(!params || !params.pageNum) {
            params = Object.assign(params,{
                pageNum: this.state.pageNum,
                pageSize: PAGE_SIZE
            })
        }
        if(params) {
            const {deliveryFromDt, deliveryToDt} = this.state
            params = Object.assign(params, {
                uncomplete: 'Y',
                notInStatusStr: 'new,audit,cancelled',
                deliveryFromDt: deliveryFromDt,
                deliveryToDt:deliveryToDt
            })
        }
        let result = ajax(baseUrl+'/api/v1/p/oms/orderList',params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data.rows
                })
            }else{
                this.setState({
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    componentDidMount() {
        this.searchList()
    }

    render() {
        const orderStatus = {
            audit:'待审核',
            audited:'待订舱',
            booked:'已订舱',
            boxed:'已装箱',
            declare:'待报关',
            declaring:'报关中',
            released:'已放行'
        };

        const logisticsStatus = {
            waiting:"待提货",
            transport:'运输中',
            declaring:'报关中',
            released:'已放行',
            boxed:'已装箱',
            destination:'已到达'
        }
        const columns = [
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                render: (text, record) => (
                    <span>
                       <LinkButton
                           onClick={() => this.props.history.push('/orderInfo', record)}>{text}</LinkButton>
                    </span>
                )
            },
           /* {
                title: '箱数CTNS',
                dataIndex: 'toNum',
            },
            {
                title: '毛重(Kg)',
                dataIndex: 'toGrossWeight',
            },
            {
                title: '总价',
                dataIndex: 'totalValue',
            },*/
            {
                title: '起运地',
                dataIndex: 'originCity',
                render: (text,record) => (
                    <span>
                        {record.originCountry}&nbsp;{text}
                  </span>
                )
            }, {
                title: '目的地',
                dataIndex: 'destinationCountry',
                render: (text,record) => (
                    <span>
                        {record.destinationCountry}&nbsp;{record.destinationCity}
                    </span>
                )
            },{
                title: '订单状态',
                dataIndex: 'orderStatus',
                render: (text,record) => (
                    <span>
                        {orderStatus[text]}
                    </span>
                )
            },{
                title: '物流状态',
                dataIndex: 'logisticsStatus',
                render: (text,record) => (
                    <span>
                        {logisticsStatus[text]}
                    </span>
                )
            },{
                title: '提货时间',
                dataIndex: 'deliveryTime',
            },
            {
                title: '操作',
                dataIndex: 'opt',
                key: 'opt',
                fixed: 'right',
                width: 100,
                render: (text,record) => (
                    <span>
                        <LinkButton onClick={()=>{
                            this.setState({
                                visible:true,
                                orderId:record.id
                            })
                        }} >设置</LinkButton>
                    </span>
                )
            },
        ];
        const form = this.props.form
        const { getFieldDecorator } = form;
        const { Option } = Select;
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <br/>
                    <Form labelCol={{
                        lg: {span: 7},
                        md: {span: 9},
                    }}
                          wrapperCol={{
                              lg: {span: 14},
                              md: {span: 12},
                          }}
                    >
                        <Row>
                            <Col span={6}>
                                <Form.Item label="订单编号">
                                    {getFieldDecorator('orderNo', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="起运地">
                                    {getFieldDecorator('departure', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="目的地">
                                    {getFieldDecorator('destination', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                        // initialValue:"马拉舍维奇",
                                    })(<Input/>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="品名(中文)">
                                    {getFieldDecorator('goodName', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="订单状态">
                                    {getFieldDecorator('orderStatus', {
                                        initialValue:'',
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        {/*<Option value="audit">待审核</Option>*/}
                                        <Option value="audited">待订舱</Option>
                                        <Option value="booked">已订舱</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="declare">待报关</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="物流状态">
                                    {getFieldDecorator('logisticsStatus', {
                                        initialValue:'',
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Option value="">全部</Option>
                                        <Option value="waiting">待提货</Option>
                                        <Option value="boxed">已装箱</Option>
                                        <Option value="transport">运输中</Option>
                                        <Option value="declaring">报关中</Option>
                                        <Option value="released">已放行</Option>
                                        {/*<Option value="destination">已到达</Option>*/}
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="提货时间">
                                    {getFieldDecorator('deliveryFromDt')(<DatePicker style={{width:"100%",minWidth:10}}
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="至">
                                    {getFieldDecorator('deliveryToDt')(<DatePicker style={{width:"100%",minWidth:10}}
                                        showTime
                                        format="YYYY-MM-DD HH:mm:ss"
                                        onChange={this.onDateChange2}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType='submit'
                                        style={{float: 'right', marginRight: '13%'}} onClick={(e)=>{
                                    e.preventDefault();
                                    this.searchList()
                                }}>查询</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Spin size="large" spinning={this.state.loading}>
                        <Table
                            rowKey='id'
                            size="middle"
                            bordered
                            columns={columns}
                            rowSelection={this.rowSelection}
                            dataSource={this.state.tableDataSource}
                            pagination={{
                                current: this.state.pageNum,
                                total:this.state.total,
                                pageSize:PAGE_SIZE,
                                showQuickJumper: true,
                                onChange:(page, pageSize)=>{
                                    this.setState({
                                        pageNum:page
                                    },()=>{
                                        this.searchList(page)
                                    })
                                }
                            }}
                        />
                    </Spin>
                </div>
                <OrderSubSetModalForm visible={this.state.visible} orderId={this.state.orderId} updateVisible={this.updateVisible}/>
            </div>
        )
    }
}
const OrderSubForm = Form.create()(OrderSubSet)
export default OrderSubForm